<template>
  <page-layout>
    <template #header>
      <div class="border-b border-gray-200 bg-white py-4">
        <div
          class="
            lg:flex lg:items-center lg:justify-between
            max-w-7xl
            mx-auto
            px-4
            sm:px-6
            lg:px-8
          "
        >
          <div class="flex-1 min-w-0">
            <h2
              class="
                text-2xl
                font-bold
                leading-7
                text-gray-900
                sm:text-3xl sm:truncate
              "
            >
              Orden de trabajo #2341
            </h2>
            <div
              class="
                mt-1
                flex flex-col
                sm:flex-row sm:flex-wrap sm:mt-0 sm:space-x-6
              "
            >
              <div class="mt-2 flex items-center text-sm text-gray-500">
                <BriefcaseIcon
                  class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
                General Motors S.A de C.V
              </div>
              <div class="mt-2 flex items-center text-sm text-gray-500">
                <CalendarIcon
                  class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
                Febrero 15 2022 - Febrero 22 2022
              </div>
            </div>
          </div>
          <div class="mt-5 flex lg:mt-0 lg:ml-4">
            <span class="hidden sm:block">
              <button
                type="button"
                class="
                  inline-flex
                  items-center
                  px-4
                  py-2
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  text-sm
                  font-medium
                  text-gray-700
                  bg-white
                  hover:bg-gray-50
                  focus:outline-none
                  focus:ring-2
                  focus:ring-offset-2
                  focus:ring-indigo-500
                "
              >
                <PencilIcon
                  class="-ml-1 mr-2 h-5 w-5 text-gray-500"
                  aria-hidden="true"
                />
                Editar
              </button>
            </span>

            <span class="hidden sm:block ml-3">
              <button
                type="button"
                class="
                  inline-flex
                  items-center
                  px-4
                  py-2
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  text-sm
                  font-medium
                  text-gray-700
                  bg-white
                  hover:bg-gray-50
                  focus:outline-none
                  focus:ring-2
                  focus:ring-offset-2
                  focus:ring-indigo-500
                "
              >
                <LinkIcon
                  class="-ml-1 mr-2 h-5 w-5 text-gray-500"
                  aria-hidden="true"
                />
                Ver cotización
              </button>
            </span>

            <span class="sm:ml-3">
              <button
                type="button"
                class="
                  inline-flex
                  items-center
                  px-4
                  py-2
                  border border-transparent
                  rounded-md
                  shadow-sm
                  text-sm
                  font-medium
                  text-white
                  bg-indigo-600
                  hover:bg-indigo-700
                  focus:outline-none
                  focus:ring-2
                  focus:ring-offset-2
                  focus:ring-indigo-500
                "
              >
                <CheckIcon class="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />
                Solicitar revisión
              </button>
            </span>

            <!-- Dropdown -->
            <Menu as="span" class="ml-3 relative sm:hidden">
              <MenuButton
                class="
                  inline-flex
                  items-center
                  px-4
                  py-2
                  border border-gray-300
                  rounded-md
                  shadow-sm
                  text-sm
                  font-medium
                  text-gray-700
                  bg-white
                  hover:bg-gray-50
                  focus:outline-none
                  focus:ring-2
                  focus:ring-offset-2
                  focus:ring-indigo-500
                "
              >
                More
                <ChevronDownIcon
                  class="-mr-1 ml-2 h-5 w-5 text-gray-500"
                  aria-hidden="true"
                />
              </MenuButton>

              <transition
                enter-active-class="transition ease-out duration-200"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
              >
                <MenuItems
                  class="
                    origin-top-right
                    absolute
                    right-0
                    mt-2
                    -mr-1
                    w-48
                    rounded-md
                    shadow-lg
                    py-1
                    bg-white
                    ring-1 ring-black ring-opacity-5
                    focus:outline-none
                  "
                >
                  <MenuItem v-slot="{ active }">
                    <a
                      href="#"
                      :class="[
                        active ? 'bg-gray-100' : '',
                        'block px-4 py-2 text-sm text-gray-700',
                      ]"
                      >Edit</a
                    >
                  </MenuItem>
                  <MenuItem v-slot="{ active }">
                    <a
                      href="#"
                      :class="[
                        active ? 'bg-gray-100' : '',
                        'block px-4 py-2 text-sm text-gray-700',
                      ]"
                      >View</a
                    >
                  </MenuItem>
                </MenuItems>
              </transition>
            </Menu>
          </div>
        </div>
      </div>
    </template>

    <template #content>
      <div
        class="
          min-h-screen
          lg:grid lg:grid-cols-12 lg:gap-x-5
          max-w-7xl
          mx-auto
          py-10
          sm:px-6
          lg:px-8
        "
      >
        <aside class="py-6 px-2 sm:px-6 lg:py-0 lg:px-0 lg:col-span-3">
          <nav class="space-y-1">
            <button
              @click="selected = item.current"
              v-for="item in navigation"
              :key="item.name"
              :href="item.href"
              :class="[
                selected == item.current
                  ? 'bg-gray-50 text-indigo-700 hover:text-indigo-700 hover:bg-white'
                  : 'text-gray-900 hover:text-gray-900 hover:bg-gray-50',
                'group rounded-md px-3 py-2 flex items-center text-sm font-medium',
              ]"
              :aria-current="selected == item.current ? 'page' : undefined"
            >
              <component
                :is="item.icon"
                :class="[
                  selected == item.current
                    ? 'text-indigo-500 group-hover:text-indigo-500'
                    : 'text-gray-400 group-hover:text-gray-500',
                  'flex-shrink-0 -ml-1 mr-3 h-6 w-6',
                ]"
                aria-hidden="true"
              />
              <span class="truncate">
                {{ item.name }}
              </span>
            </button>
          </nav>
        </aside>

        <div class="space-y-6 sm:px-6 lg:px-0 lg:col-span-9">
          <LightningForm v-if="selected == 'forms'" />
          <Calendar v-if="selected == 'calendar'" />
          <Money v-if="selected == 'money'" />
        </div>
      </div>
    </template>
  </page-layout>
</template>

<script>
import {
  ClipboardListIcon,
  CalendarIcon,
  CreditCardIcon,
} from "@heroicons/vue/outline";

import {
  BriefcaseIcon,
  CheckIcon,
  ChevronDownIcon,
  CurrencyDollarIcon,
  LinkIcon,
  LocationMarkerIcon,
  PencilIcon,
} from "@heroicons/vue/solid";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";

import LightningForm from "./Lightning/LightningForm";
import Calendar from "./Lightning/Calendar";
import Money from "./Lightning/Money";

const navigation = [
  { name: "Calendario", href: "#", icon: CalendarIcon, current: "calendar" },
  { name: "Mediciones", href: "#", icon: ClipboardListIcon, current: "forms" },
  {
    name: "Estado de cuenta",
    href: "#",
    icon: CreditCardIcon,
    current: "money",
  },
];

import PageHeader from "@/Shared/Organisms/PageHeader";
import AppLayout from "@/Layouts/AppLayout";
import PageLayout from "@/Layouts/PageLayout";

export default {
  layout: AppLayout,

  components: {
    LightningForm,
    PageHeader,
    PageLayout,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    BriefcaseIcon,
    CalendarIcon,
    CheckIcon,
    ChevronDownIcon,
    CurrencyDollarIcon,
    LinkIcon,
    LocationMarkerIcon,
    PencilIcon,
    Calendar,
    Money,
  },

  setup() {
    return {
      navigation,
    };
  },
  data() {
    return {
      selected: "calendar",
    };
  },
};
</script>

